<tt-page>
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-list-legacy [listItems]="itemsListStockAlls" [ttBadge]="'badgeinfo'" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="stockall_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="80">
                    <tt-list-legacy [listItems]="itemsListStockAlls" [ttBadge]="'badgeinfo'" ltype="multi" [designVar]="'s12t0'" typevar="g"></tt-list-legacy>
                </tt-divider-pane>

                <tt-divider-pane ttSize="20"></tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
